module.exports = __webpack_public_path__ + "static/media/1POLICY34.b94c9274.jpg";